import { Tbody } from '@chakra-ui/react';
import EmptyTableRow from 'src/components/common/EmptyTableRow';
import { Mode } from 'src/types/crudTable';
import { TableRow } from './TableRow';
import { useTableContext } from './useTableContext';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var TableBody = function TableBody(_ref) {
  var isDisabled = _ref.isDisabled;

  var _useTableContext = useTableContext(),
      table = _useTableContext.table,
      changes = _useTableContext.changes,
      mode = _useTableContext.mode;

  var columnsLength = table.getVisibleFlatColumns().length;
  return /*#__PURE__*/_jsxs(Tbody, {
    e2eid: "CrudTable_TableBody_Tbody",
    children: [table.getRowModel().rows.length === 0 && /*#__PURE__*/_jsx(EmptyTableRow, {
      columnsLength: columnsLength,
      e2eid: "CrudTable_TableBody_EmptyTableRow"
    }), table.getRowModel().rows.map(function (row) {
      var _row$original;

      var _isDisabled = Boolean(isDisabled || row._disable || ((_row$original = row.original) === null || _row$original === void 0 ? void 0 : _row$original._disable));

      return /*#__PURE__*/_jsx(TableRow, {
        row: row,
        isDisabled: _isDisabled,
        rowToSave: changes[row.id],
        isPreview: mode === Mode.PREVIEW,
        e2eid: "CrudTable_TableBody_TableRow"
      }, row.id);
    })]
  });
};